import script from "./search-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-form.vue?vue&type=script&setup=true&lang=ts"

import "./search-form.vue?vue&type=style&index=0&id=02494c56&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02494c56"]])

export default __exports__